module.exports = __webpack_public_path__ + "img/certificate4.14401fdc.jpg";